export default __webpack_public_path__ + "static/media/1421.75bbd4f2.png";